import { Button } from "../../../components/ui/button";
import { Card } from "../../../components/ui/card";

export const AboutSection = () => {
  const numerologyNumbers = [8, 3, 5, 8, 6, 5];

  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="bg-gradient-to-b from-cosmic-blue/10 to-background-blue">
      <div className="container mx-auto px-6">
        {/* Floating Numbers */}
        <div className="flex justify-center mb-16 space-x-2 sm:space-x-4">
          {numerologyNumbers.map((number, index) => (
            <div 
              key={index}
              className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-cosmic-gold to-cosmic-gold-dark flex items-center justify-center text-xl sm:text-2xl font-bold text-primary-foreground shadow-[0_0_20px_hsl(var(--mystic-gold)/0.4)] animate-bounce"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {number}
            </div>
          ))}
        </div>

        {/* About Numerology */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl uppercase tracking-wider text-cosmic-gold mb-8">ASTROLOGY</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            is an ancient science that reveals how the positions of planets, stars, and constellations at the time of your birth shape your personality, emotions, strengths, challenges, and life events. We use time-tested Vedic astrology techniques to analyze your birth chart (Kundli) in detail and provide you with deep insights. This report will not only help you understand yourself better but also guide you in making wise decisions about career, relationships, health, and finance, aligning your life with cosmic energies for growth and harmony.
          </p>
        </div>

        {/* Social Proof */}
        <Card className="p-8 md:p-12 bg-gradient-to-b from-cosmic-gold/10 to-cosmic-glow/10 border-cosmic-gold/30 backdrop-blur-sm">
          <div className="text-center">
            <div className="text-6xl font-bold text-cosmic-gold mb-4">10L+</div>
            <div className="text-xl text-foreground font-semibold mb-8">REPORTS HAVE BEEN SOLD ALREADY!</div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={handleScrollToPricing} variant="cosmic" size="xl">
                GET YOUR REPORT NOW
              </Button>
              <Button onClick={handleScrollToPricing} variant="cosmic-outline" size="xl" className="hidden md:block">
                GET YOUR REPORT NOW
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};